module.exports = __webpack_public_path__ + "img/coupons_v1.3faf675.png";